import './admin/sass/_admin.scss'
import './admin/sass/_admin_basic.scss'
import React, { useState, useEffect, useContext } from "react";
import MainPage from "./admin/Device/MainPage";
import InternetSettings from "./admin/InternetSettings/Internet_settings";
import BackUpSetting from "./admin/Server/BackUp";
import UserMainPage from "./admin/User/User_main_page";
import ConnectionHisGraphyNew from './admin/User/Connection_His/Connection_His_Graphy_New';
import PngReader from './admin/BackStage/PngReader';
import LineChannel from './admin/BackStage/LineChannel';
import ServerSetting from './admin/Server/ServerSetting';
import AlertFilter from './admin/BackStage/AlertFilter';
import { useTranslation } from 'react-i18next';
import { resources } from '../i18n'
import comm_imgs from '../comm_imgs';
import AddPopUp from './popUp/AddPopUp';
// import ProdkeySetting from './admin/Server/prodkey/ProdkeySetting';
import Modal from './modal/Modal';
import ConnectionList from './admin/User/Connection_His/Connectionlist';
import Account from '../actions/Account';
import ApiGo from '../actions/ApiGo';
import UpdateSetting from './admin/BackStage/UpdateSetting';
import { SpeakTest } from './admin/BackStage/AlertSpeakTest';
import { useDispatch } from 'react-redux';
import { ADD_BEDS_ARRAY } from '../stores/reducer_beds';
import { ADD_ALL_MAC_ALERTS_SETTING_ARRAY } from '../stores/reducer_padsArray';
import { ADD_USERS_ARRAY } from '../stores/reducer_usersArray';
import { ADD_RESIDENTS_ARRAY } from '../stores/reducer_residentsArray';
import Mos from '../actions/Mos';
import Institution from './admin/institution/Institution';
import ConfigHandler from '../actions/ConfigHandler';

const AdminCtx = React.createContext();

const NavBar = [
    {index:0, id:"Node", className:"link_admin font-xs", tabName:"ADMIN.DEVICE", tabName2:"ADMIN.OVERLOOK", imgs:comm_imgs.NODE_PADS},
    {index:1, id:"User", className:"link_admin font-xs", tabName:"ADMIN.USERS", tabName2:"ADMIN.MANAGEMENT", imgs:comm_imgs.ADMIN_USERS},
    {index:2, id:"BackUpSetting",className:"link_admin font-xs",  tabName:"ADMIN.SERVER", tabName2:"ADMIN.MANAGEMENT", imgs:comm_imgs.SERVER},
    {index:3, id:"Alert",className:"link_admin font-xs",  tabName:"ADMIN.OTHER", tabName2:"ADMIN.SETTING", imgs:comm_imgs.OTHER},
]
let defaultShow=[false, false, false, false, false]

function Layout_for_Admin(props){
    const mos = Mos()
    const [logoutBtn, setLogoutBtn] = useState(false);
    function toggleLogoutBtn(){setLogoutBtn(!logoutBtn)}
    const [panel, setPanel] = useState();
    const [clickSelected, setClickSelected] = useState(defaultShow);
    // archiving開關
    const [archivingBool, setArchivingBool] = useState(false);
    // 選擇：**存 translation key 而非已翻譯字串**
    const [selectedKey, setSelectedKey] = useState("ADMIN.ALL"); // 預設 key（會用 t(selectedKey) 顯示）
    const [navBarPopout, setNavBarPopout] = useState(0);
    const [navBarSet, setNavBarSet] = useState(false);

    // i18n 組合
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const lng_choice = Object.entries(resources).map( res=> res[1].title )
    lng_choice.unshift(t('GLOBAL.CHANGE_LANGUAGE'))
    const DP_data = {keys:lng_choice}
    const [returnLng, setReturnLng] = useState("");     //dropdown return result
    // language 存為預設
    function storeLanguageToStorage(lng) {
        localStorage.setItem("i18nextLng", lng)
        sessionStorage.setItem("i18nextLng", lng)
    }
    // language 修改
    useEffect(()=>{
        let result = Object.entries(resources).filter( res=>res[1].title === returnLng )[0]
        if(result!==undefined){
            storeLanguageToStorage(result[0])
            i18n.changeLanguage(result[0])
        }
    }, [returnLng, i18n])
    // 換語言按鈕 新版 (非dropdown)
    const [lngBtn, setLngBtn] = useState(false);
    function toggleLngBtn(){ setLngBtn(!lngBtn) }

    // 初始載入 panel 並設定預設 selectedKey
    useEffect(() => {
        Panel_NavBar_Bind(<MainPage />, [true, false, false, false, false, false]);
        setSelectedKey("ADMIN.ALL_DEVICES"); // 初始標題使用 key（會由 t(...) 顯示）
    },[]);

    useEffect(()=>{
        if(props.serverVersioin==="desktop") setNavBarSet(true)
    }, [props.serverVersioin])

    const [refresh, setRefresh] = useState(true);
    // ------------------ redux ------------------
    const dispatch = useDispatch()
    useEffect(() => {
        if(!refresh){
            setRefresh(false)
            return
        }
        const initStatus = ConfigHandler.initStatus();
        ApiGo.getResidents()
            .then(res=>{dispatch(ADD_RESIDENTS_ARRAY(res))})
            .catch(err=>{console.log(err);})
        ApiGo.getUsers()
            .then(res=>{dispatch(ADD_USERS_ARRAY(res.users))})
            .catch(err=>{console.log(err);})
        ApiGo.getBed()
            .then(res=>{dispatch(ADD_BEDS_ARRAY(res.beds) || [])})
            .catch(err=>{console.log(err);})
        ApiGo.getAll_mac_alert_setting()
            .then(res=>{dispatch(ADD_ALL_MAC_ALERTS_SETTING_ARRAY(res))})
            .catch(err=>{console.log(err);})
        setRefresh(false)
    }, [dispatch, refresh]);
    // ------------------ redux ------------------

    // 統一Panel和nav bar ui 選擇顯示
    function Panel_NavBar_Bind(panel, clk) {
        setPanel(panel);
        setClickSelected(clk)
    }

    function toSwitchManage(e) {
        switch (e.target.id) {
            case "Node":
                setSelectedKey("ADMIN.ALL_DEVICES");
                Panel_NavBar_Bind(<MainPage /> , [true, false, false, false, false]);
                break;
            case "Internet":
                setSelectedKey("ADMIN.NETWORK_MANAGEMENT");
                Panel_NavBar_Bind(<InternetSettings /> , [false, false, true, false, false]);
                break;
            case "User":
                setSelectedKey("ADMIN.USER_MANAGEMENT");
                Panel_NavBar_Bind(<UserMainPage /> , [false, true, false, false, false]);
                break;
            case "Connection_his":
                setSelectedKey("ADMIN.CONNECTION_HISTORY");
                Panel_NavBar_Bind(<ConnectionHisGraphyNew mos={mos} /> , [false, true, false, false, false])
                break;
            case "BackUpSetting":
                setSelectedKey("ADMIN.BACKUP_MANAGEMENT");
                Panel_NavBar_Bind(<BackUpSetting /> , [false, false, true, false, false])
                break;
            case "ServerSetting":
                setSelectedKey("ADMIN.SERVER_MANAGEMENT");
                Panel_NavBar_Bind(<ServerSetting /> , [false, false, true, false, false])
                break;
            case "UpdateSetting":
                setSelectedKey("ADMIN.UPDATE_MANAGEMENT");
                Panel_NavBar_Bind(<UpdateSetting mos={mos} /> , [false, false, true, false, false])
                break;
            case "Backstage":
                setSelectedKey("ADMIN.OTHER_SETTINGS");
                Panel_NavBar_Bind(<PngReader /> , [false, false, false, false, true])
                break;
            case "Line":
                setSelectedKey("ADMIN.OTHER_SETTINGS");
                Panel_NavBar_Bind(<LineChannel /> , [false, false, false, false, true])
                break;
            case "Alert":
                setSelectedKey("ADMIN.OTHER_SETTINGS");
                Panel_NavBar_Bind(<AlertFilter /> , [false, false, false, false, true])
                break;
            case "Test":
                setSelectedKey("ADMIN.OTHER_SETTINGS");
                Panel_NavBar_Bind(<SpeakTest mos={mos}/> , [false, false, false, false, true])
                break;
            case "AddInstitution":
                setSelectedKey("ADMIN.INSTITUTION_SETTINGS");
                Panel_NavBar_Bind(<Institution /> , [false, false, false, true, false])
                break;
            default:
                break;
        }
    }
    return(
        <AdminCtx.Provider
            value={{
                archivingBool: archivingBool,
                setArchivingBool: setArchivingBool
            }}>
        {archivingBool ? <Modal /> : null}
        <div className="bgC-white-gray">
            <AddPopUp />
            <div className="font-s fx-fsfs wid-admin-full hig-full ">
                <nav className="font-ml fx-d-c fx-cfs bgC-white wid-admin-xs hig-full pos-f z-2 left_display">
                {NavBar.map((tab, index)=>{
                    let style = (clickSelected[tab.index]===true)? tab.className + ' active' : tab.className;
                    return <div id={tab.id} key={tab.id} className={style+" w-100 margt-m-vh fx-d-c fx-ccc"}
                        onClick={toSwitchManage}
                        onMouseEnter={()=>setNavBarPopout(index)}
                        onMouseLeave={()=>setNavBarPopout(0)}>
                        <img src={tab.imgs} className="pt_event_none pic_admin" alt={t(tab.tabName)} />
                        <div className='pt_event_none font-m'>{t(tab.tabName)}</div>
                        {(navBarPopout===1 && index===1)?<div className='pos-a l-100 bgC-light fx-d-c '>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="User" onClick={toSwitchManage}>{t("ADMIN.USERS")}{t("ADMIN.MANAGEMENT")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Connection_his" onClick={toSwitchManage}>{t("ADMIN.CONNECTION_HIS")}</div>
                        </div>:null}
                        {(navBarPopout===2 && index===2)?<div className='pos-a l-100 bgC-light fx-d-c '>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="UpdateSetting" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.UPDATE_MANAGEMENT")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="BackUpSetting" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.BACKUP_MANAGEMENT")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="ServerSetting" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.SERVER_MANAGEMENT")}</div>
                            {!navBarSet?<div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Internet" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.NETWORK_SETTING.WIFI_SETTING")}</div>:null}
                        </div>:null}
                        {(navBarPopout===3 && index===3)?<div className='pos-a l-100 bgC-light fx-d-c '>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Alert" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.ALERT_FILTER")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Test" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.ALERT_TEST")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Line" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.LINE_NOTIFY")}</div>
                            <div className='wid-admin-12 font-m fx-d-c fx-ccc pad-5 t b pad-15 l r border'
                                id="Backstage" onClick={e=>{toSwitchManage(e)}}>{t("ADMIN.PNG_MANAGEMENT")}</div>
                        </div>:null}
                    </div>
                })}
                </nav>
                <div className="wid-admin-full hig-s fx-cspbt pos-a z-1">
                    {/* 顯示改為動態用 t(selectedKey) */}
                    <div className="bgC wid-admin-25 hig-7 left_display ld5 fx-cfs font-xl"><div className="header margl-30">{t(selectedKey)}</div></div>
                    <div className="col fx-d-r fx-fec font-ml cancel-pad margr-xs" >
                        <div className="fx-d-c pad-15 l " onClick={toggleLngBtn}>
                            <div className={`fx-d-c fx-ccc font-l nav-logout ${(lngBtn)? "activate":""}`}>
                                <div>{t("GLOBAL.CHANGE_LANGUAGE")}</div>
                            </div>
                            <div>
                                {lngBtn? <DropdownLNG
                                    hide={toggleLngBtn}
                                    data={DP_data}
                                    setReturnLng={setReturnLng}
                                    />:null}
                            </div>
                        </div>
                        <div className="fx-d-c pad-15 l" onClick={toggleLogoutBtn}>
                            <div className={`fx-d-c fx-ccc font-l nav-logout ${(logoutBtn)? "activate":""}`}>
                                <div>{t("AUDIT_TRAIL.EVENTS.LOGOUT")}</div>
                            </div>
                            <div className="bdr">
                                {logoutBtn? <LogoutBtn hide={toggleLogoutBtn} />:null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="innerDiv_admin font-s  of-auto margl-xxs">{panel}</div>
            </div>
            <footer className="font-m pos-f b-0 r-0 z-1 bgC-white">© {new Date().getFullYear()} {t("GLOBAL.BRAND")}</footer>
        </div>
        </AdminCtx.Provider>
    );
}

export default Layout_for_Admin;
export { AdminCtx };

const LogoutBtn =(props)=>{
    const {t} = useTranslation()
    function logout() { new Account().logout() }
    return(
        <div onClick={props.hide} className="pos-f z-2 wid-admin-full hig-full top-0 left-0">
            <div className="pos-a r-0 marg-t" onClick={e => e.stopPropagation()}>
                <div className="fx-d-r skew parallel-before">
                    <div className="parallel first fx-ccc" onClick={logout} >
                        <div className="skew-revese fx-ccc pad-3 b pad-5 t">
                            {t("AUDIT_TRAIL.EVENTS.LOGOUT")}
                        </div>
                    </div>
                    <div className="parallel second fx-ccc" onClick={props.hide}>
                        <div className="skew-revese fx-ccc pad-3 b pad-5 t">
                            {t("GLOBAL.CANCEL")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

const DropdownLNG = (props) => {
    const Parrel = props.data.keys.map((k, index)=>{
        return (
            <div key={index+k} className="fx-d-c">{index===0?
                <div className="parallel first fx-ccc pad-3 b pad-5 t" >
                    <div className="skew-revese unselc">
                        {k}
                    </div>
                </div>:
                <div className="parallel second slash pad-3 b pad-5 t" onClick={e=>props.setReturnLng(e.target.id)} id={k}>
                    <div className="skew-revese unselc">
                        {(k==="English (US)")? "English":k}
                    </div>
                </div>
                }
            </div>
            )
        }
    )

    return (
        <div onClick={props.hide} className="pos-f z-2 wid-full hig-full top-0 left-0">
            <div className="pos-a r-0 marg-t r-45" onClick={e => e.stopPropagation()}>
                <div className="fx-d-r skew parallel-before">
                    {Parrel}
                </div>
            </div>
        </div>
    )
}